var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9927C0 15.9559 2.46177 13.4941 5.49851 13.4941V13.4941C8.53526 13.4941 10.997 15.9559 10.997 18.9927V23.5218C10.997 24.0756 10.5481 24.5245 9.99426 24.5245H1.00276C0.448951 24.5245 0 24.0756 0 23.5218V18.9927Z",
    fill: "#7AA2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4063 19.6321C24.4063 22.5988 22.0012 25.0039 19.0344 25.0039V25.0039C16.0676 25.0039 13.6626 22.5988 13.6626 19.6321L13.6626 15.2075C13.6626 14.6665 14.1012 14.2279 14.6422 14.2279L23.4266 14.2279C23.9677 14.2279 24.4063 14.6665 24.4063 15.2075L24.4063 19.6321Z",
    fill: "#497FEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.952197C0 0.7154 0.191962 0.523438 0.42876 0.523438H8.63047C9.01214 0.523438 9.20358 0.984632 8.9341 1.25492L0.732393 9.48129C0.462476 9.75202 0 9.56086 0 9.17857L0 0.952197Z",
    fill: "#405FEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9922 11.124C10.9922 11.3608 10.8002 11.5527 10.5634 11.5527L2.36172 11.5527C1.98004 11.5527 1.78861 11.0915 2.05808 10.8213L10.2598 2.59488C10.5297 2.32415 10.9922 2.51531 10.9922 2.8976L10.9922 11.124Z",
    fill: "#405FEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4063 6.05422C24.4063 9.09097 21.9445 11.5527 18.9077 11.5527V11.5527C15.871 11.5527 13.4092 9.09096 13.4092 6.05422L13.4092 1.52538C13.4092 0.971583 13.8582 0.522643 14.412 0.522643L23.4035 0.522644C23.9573 0.522644 24.4063 0.971584 24.4063 1.52538L24.4063 6.05422Z",
    fill: "#497FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuIconActive);
export default __webpack_public_path__ + "static/media/zunu_icon_active.eed659c3f80359a397bce608b921b97b.svg";
export { ForwardRef as ReactComponent };